<template>
    <div class="duplicate-review-filter-bar">
        <el-switch
            :value="onlyPending"
            active-text="只看待复核"
            @input="$emit('toggle-only-pending', $event)"
        />
        <el-radio-group
            :value="value"
            size="mini"
            :disabled="onlyPending"
            @input="$emit('input', $event)"
        >
            <el-radio-button label="pending">待定</el-radio-button>
            <el-radio-button label="useful">有用</el-radio-button>
            <el-radio-button label="not-useful">无用</el-radio-button>
            <el-radio-button label="all">全部</el-radio-button>
        </el-radio-group>
        <span class="duplicate-review-filter-bar__label">一级分类</span>
        <el-select
            :value="llmCategoryLevel1"
            size="mini"
            clearable
            filterable
            placeholder="选择一级分类"
            class="duplicate-review-filter-bar__input"
            @input="$emit('category-change', $event)"
        >
            <el-option
                v-for="item in level1Options"
                :key="item"
                :label="item"
                :value="item"
            />
        </el-select>
    </div>
</template>

<script>
export default {
    name: "DuplicateReviewFilterBar",
    data() {
        return {
            level1Options: ["医疗类", "物损类", "单据类", "现场类", "证件类", "其他"],
        };
    },
    props: {
        value: {
            type: String,
            default: "pending",
        },
        onlyPending: {
            type: Boolean,
            default: true,
        },
        llmCategoryLevel1: {
            type: String,
            default: "",
        },
    },
};
</script>

<style scoped>
.duplicate-review-filter-bar {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.duplicate-review-filter-bar__label {
    color: #606266;
    font-size: 13px;
}

.duplicate-review-filter-bar__input {
    width: 260px;
}
</style>
